import { wireCopyButton } from "./copy-button.js";
import { plainFlavours } from "./copy-html.js";
import { element } from "./dom.js";
import type { NumeralReading } from "./numbers.js";

/**
 * Drawing the readings of a number.
 *
 * One row per way of saying it, each with the characters, the pinyin and a
 * copy button. Rows for readings the number does not have are simply absent
 * rather than empty — a decimal has no separate digit-by-digit reading, and a
 * number with no 1 in it has no `yāo` one.
 */

/**
 * One reading as a row: what it is called, the characters, and the pinyin.
 */
export function readingRow(
  label: string,
  note: string,
  reading: NumeralReading,
): Node {
  const copy = element("button", {
    className: "cb-tool-button",
    text: "Copy",
    attributes: { type: "button" },
  });

  wireCopyButton(copy, () =>
    plainFlavours(`${reading.hanzi} ${reading.pinyin}`),
  );

  return element("div", {
    className: "cb-number-reading",
    children: [labelCell(label, note), saidCell(reading), copy],
  });
}

/** What this way of saying the number is called, and when it is the one. */
function labelCell(label: string, note: string): Node {
  return element("div", {
    className: "cb-number-label",
    children: [
      element("span", { className: "cb-number-label-name", text: label }),
      element("span", { className: "cb-tool-note", text: note }),
    ],
  });
}

/** The characters, and how they are read. */
function saidCell(reading: NumeralReading): Node {
  return element("div", {
    className: "cb-number-said",
    children: [
      element("span", {
        className: "cb-number-hanzi hanzi",
        text: reading.hanzi,
        attributes: { lang: "zh-Hans" },
      }),
      element("span", {
        className: "cb-number-pinyin pinyin",
        text: reading.pinyin,
        attributes: { lang: "zh-Latn-CN-pinyin" },
      }),
    ],
  });
}
